import { atomWithReset as stateSegmentWithReset } from 'jotai/utils';

export const isReloggingAfterTimeoutSegment =
  stateSegmentWithReset<boolean>(false);

isReloggingAfterTimeoutSegment.debugLabel = 'isReloggingAfterTimeoutSegment';
